export default __webpack_public_path__ + "static/media/17.32dce78b.png";